import http from '../../../../libs/http'
export default () => http.get(`${process.env.VUE_APP_MICROSERVICE_API_SHOPS}/presentation`)
